var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBtcp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m23.1 3.68-.98 3.979c3.03 1.057 5.26 2.645 4.825 5.585-.126.893-.434 1.788-1.07 2.464-.544.583-1.395.892-2.122 1.13a9.044 9.044 0 0 1-2.702.475 20.53 20.53 0 0 1-1.83-.073c-.997-.074-2.013-.165-2.992-.384-.308-.073-.599-.127-.87-.201l-1.325 5.348-.78 2.92-.98 3.998-2.41-.602.998-4.033c-.562-.146-1.143-.31-1.723-.457L6 23.046l1.197-2.758s1.778.476 1.758.44c.69.164.98-.293 1.106-.584l1.362-5.477.634-2.537.727-2.92c.035-.51-.146-1.168-1.126-1.406.037-.018-1.758-.438-1.758-.438l.633-2.591 3.318.84c.51.126 1.018.236 1.544.364l.98-3.98 2.41.602-.96 3.906c.635.147 1.288.293 1.923.456l.942-3.887 2.41.603zm-.198 14.42c.67-.11 1.487-.384 2.067-.622.017-.018.055-.018.071-.036 1.253 1.113 1.85 2.92 1.035 5.239-1.288 3.761-4.388 4.07-8.487 3.287L16.59 30l-2.393-.602.924-3.851.037-.128.727-2.96c2.14.477 5.023.786 5.566-1.44.292-1.187-.271-2.045-1.178-2.665l.943-.056c.672-.036 1.015-.09 1.687-.201zm-.708-4.893c.708-2.866-3.682-3.486-5.04-3.85l-1.199 4.854c1.361.348 5.568 1.735 6.239-1.003z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtcp);
export default __webpack_public_path__ + "static/media/BTCP.b4fa42fbd715ec74b238f9ef8dc3d3c2.svg";
export { ForwardRef as ReactComponent };